module.exports = __webpack_public_path__ + "static/media/Mystino-home-test.ee50d35d.jpg";